export default __webpack_public_path__ + "static/media/Stage1_title.5224d615.png";